import { gql, useMutation } from "@apollo/client";

export interface ChannelBaseInput {
    bdName?: string;
    englishShortName?: string;
    onboardingDocumentsJson?: string;
    responsibleNode?: number;
    customerType?: number;
    pickupHubMatchingType?: number;
    fixedPickupHubId?: number;
    contractingPartyId?: number | null;
}

export interface ChannelSettlementInput {
    netDay?: number;
    orderQuantityLimit?: number;
    orderDailyLimit?: number;
    orderCycleLimit?: number;
    gri?: string;
    dimDivisor?: number;
    // 冗余字段（双写）
    settlementTrackingPoint?: string;
    billingCycleConfiguration?: number;
    weightCalculationMode?: number;
    weightCalculationThresholdX?: number;
    settlementMode?: number;
    timeZoneIana?: string;
    schemeLimitNode?: string;
    settlementCustomerType?: number;
    billType?: string;
    billUnitType?: number;
    billTypeCycleList?: Array<{ billType: number; cycleType: number }>;
}

export interface ChannelContactInput {
    financeContactName?: string;
    financeContactEmail?: string;
    financeContactsJson?: string;
    itContactName?: string;
    itContactEmail?: string;
}

export interface ChannelFulfillmentInput {
    forwardTimeValue?: number;
    forwardTimeDisplayUnit?: number;
    failureMethod?: number;
    storageTimeValue?: number;
    storageTimeDisplayUnit?: number;
    returnTimeValue?: number;
    returnTimeDisplayUnit?: number;
    trackDiscontinuationAssessmentType?: number;
    trackDiscontinuationAssessmentDays?: number | null;
}

export interface SaveChannelExtendedInfoInput {
    channelId: number;
    channelBase?: ChannelBaseInput;
    channelSettlement?: ChannelSettlementInput;
    channelContact?: ChannelContactInput;
    channelFulfillment?: ChannelFulfillmentInput;
}

export const SAVE_CHANNEL_EXTENDED_INFO = gql`
    mutation SaveChannelExtendedInfo(
        $channelId: Long!,
        $channelBase: ChannelBaseInput,
        $channelSettlement: ChannelSettlementInput,
        $channelContact: ChannelContactInput,
        $channelFulfillment: ChannelFulfillmentInput
    ) {
        saveOrUpdateChannelExtendedInfo(
            channelId: $channelId,
            channelBase: $channelBase,
            channelSettlement: $channelSettlement,
            channelContact: $channelContact,
            channelFulfillment: $channelFulfillment
        ) {
            channelBase {
                id
                channelId
                bdName
                englishShortName
                responsibleNode
                customerType
                pickupHubMatchingType
                fixedPickupHubId
            }
            channelSettlement {
                id
                channelId
                netDay
                orderQuantityLimit
                orderDailyLimit
                orderCycleLimit
                gri
                dimDivisor
            }
            channelContact {
                id
                channelId
                financeContactName
                financeContactEmail
                financeContactsJson
                itContactName
                itContactEmail
            }
            channelFulfillment {
                id
                channelId
                forwardTimeValue
                forwardTimeDisplayUnit
                failureMethod
                storageTimeValue
                storageTimeDisplayUnit
                returnTimeValue
                returnTimeDisplayUnit
                trackDiscontinuationAssessmentType
                trackDiscontinuationAssessmentDays
            }
        }
    }
`;

export interface SaveChannelExtendedInfoResponse {
    saveOrUpdateChannelExtendedInfo: {
        channelBase?: {
            id: string;
            channelId: number;
            bdName?: string;
            englishShortName?: string;
            responsibleNode?: number;
            customerType?: number;
            pickupHubMatchingType?: number;
            fixedPickupHubId?: number;
        };
        channelSettlement?: {
            id: string;
            channelId: number;
            netDay?: number;
            orderQuantityLimit?: number;
            orderDailyLimit?: number;
            orderCycleLimit?: number;
            gri?: string;
            dimDivisor?: number;
        };
        channelContact?: {
            id: string;
            channelId: number;
            financeContactName?: string;
            financeContactEmail?: string;
            financeContactsJson?: string;
            itContactName?: string;
            itContactEmail?: string;
        };
        channelFulfillment?: {
            id: string;
            channelId: number;
            forwardTimeValue?: number;
            forwardTimeDisplayUnit?: number;
            failureMethod?: number;
            storageTimeValue?: number;
            storageTimeDisplayUnit?: number;
            returnTimeValue?: number;
            returnTimeDisplayUnit?: number;
            trackDiscontinuationAssessmentType?: number;
            trackDiscontinuationAssessmentDays?: number | null;
        };
    };
}

export interface SaveChannelExtendedInfoVariables {
    channelId: number;
    channelBase?: ChannelBaseInput;
    channelSettlement?: ChannelSettlementInput;
    channelContact?: ChannelContactInput;
    channelFulfillment?: ChannelFulfillmentInput;
}

export const useSaveChannelExtendedInfo = () => {
    return useMutation<SaveChannelExtendedInfoResponse, SaveChannelExtendedInfoVariables>(
        SAVE_CHANNEL_EXTENDED_INFO
    );
};

